 
<div class="row col-lg-12 col-md-12 col-sm-12 col-12">
  <div class="col-lg-10 col-md-10 col-sm-12 col-12 login-form">
    <div class="center-screen container-login100 bodybg-color">
      <p-card class="customCard">
        <p-header class="customHeader"> 
          <h3 class="text-center mt-0 m-b-15">
            <img src="/assets/v2/img/logo-color-baseline-V62-slogan-black.svg" alt="logo"> 
          </h3>
          <span class="headerTitle">
            S'authentifier
          </span>
        </p-header>
        <div class="row">
          <div class="col">
            <form [formGroup]="sendCodeForm" (ngSubmit)="sendCode()" action="#" novalidate>
              <div class="row">
                <div class="col">
                  Sélectionner un moyen pour recevoir le code d'authentification à deux facteurs :
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4" *ngFor="let p of providers">
                  <div class="input-group form-group remember-me-container">
                    <div class="input-group-prepend">
                      <p-radioButton formControlName="factor" name="factor" value="{{p.Name}}"></p-radioButton>
                    </div>
                    <span class="remember-me-label">{{p.DisplayedValue}}</span>
                  </div>
                </div>
              </div>
              <div class="row alert alert-info" *ngIf="selectedProvider != null && infoMessage != null">
                {{infoMessage}}.
              </div>
              <div class="row" style="margin-top: 20px;">
                <div class="col-md-12 col-connect-action">
                  <button type="button" class="btn btn-primary" (click)="sendCode()">
                    <span class="btn-label">
                      <i class="pi pi-unlock"></i>
                    </span>Envoyer
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </p-card>
    </div> 
  </div>
</div>
